import { AxiosError } from 'axios'
import { redirect } from 'react-router-dom'

import { usePersistStore } from './hooks/usePersistStore'

const isAxiosError = (error: unknown | AxiosError): error is AxiosError => {
  return !!(error as AxiosError)?.response?.status
}

const apiErrorHandler = (error: unknown | AxiosError): void => {
  const store = usePersistStore.getState()

  if (isAxiosError(error) && error?.response?.status === 401) {
    if (window.location.pathname !== '/sign-in') {
      if (window.location.pathname !== '/') {
        store.persistUrlData()
      }

      if (window.location.search?.includes('chat-modal-open')) {
        store.setChatModalOpen(true)
      }

      if (window.location.search?.includes('chat-id-to-open')) {
        const splittedSearch = window.location.search.split('=')
        if (splittedSearch[1]) {
          store.setChatIdToOpen(splittedSearch[1])
        }
      }

      redirect('/sign-in')
      window.location.reload()
    }
    return
  }

  throw error
}

export default apiErrorHandler
